import {Component, inject, input} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {ProductCardImagesService} from "../../../services/product-card-images.service";
import {ProductCardImagesStateService} from "../../../services-state/product-card-images-state.service";
import {FilesService} from "../../../../../../core/services/files.service";
import {ProductCardImage} from "../../../types/product-card-image.types";
import {
  ProductCardImagesModalComponent
} from "../../modals/product-card-images-modal/product-card-images-modal.component";
import {ImgFallbackDirective} from "../../../../../../shared/directives/img-fallback.directive";

@Component({
  selector: 'app-pc-images',
  standalone: true,
  imports: [
    ImgFallbackDirective
  ],
  templateUrl: './pc-images.component.html',
  styleUrl: './pc-images.component.scss'
})
export class PcImagesComponent {
  productCardId = input<number>(0);
  productCardAvatar = input<string>('');

  private productCardImagesService: ProductCardImagesService = inject(ProductCardImagesService);
  private productCardImagesStateService: ProductCardImagesStateService = inject(ProductCardImagesStateService);
  private filesService: FilesService = inject(FilesService);
  private dialog: MatDialog = inject(MatDialog);

  public firstImg: string = '';
  private firstImgId: number = 0;

  public async handelAttachImage() {
    this.dialog.open(ProductCardImagesModalComponent, {
      data: {
        recordId: this.productCardId(),
        parentId: this.productCardId(),
        type: 'PRODUCT_CARD'
      }
    }).afterClosed().subscribe(async () => {
      await this.getFirstImg();
    });
  }

  private async getImages(): Promise<void> {
    if (!this.productCardId()) { return; }

    await this.productCardImagesService.getProductCardImages(this.productCardId())
      .then((productCardImages) => this.updateFilesData(productCardImages));
  }

  private async updateFilesData(productCardImages: Array<ProductCardImage>): Promise<void> {
    productCardImages.forEach(image => {
      this.productCardImagesStateService.updateFilesData(image);
    });

    await this.getFirstImg();
  }

  private async getFirstImg(): Promise<void> {
    if (this.firstImgId === this.productCardImagesStateService.productCardImagesState().at(0)?.file.id) { return; }

    this.firstImgId = this.productCardImagesStateService.productCardImagesState().at(0)?.file.id || 0;
    this.firstImg = this.firstImgId ?
      await this.filesService.downloadFileNoEvents(this.firstImgId) :
      '';
  }
}
